import React from 'react';
import { Alert } from 'reactstrap';

// Internal mapping of metadata keys to display names
const attributeLabels: Record<string, string> = {
  fortnoxUrl: 'Nummer i vår Fortnox',
  qvantiId: 'Qvanti ID',
  externalFortnoxUrl: 'Nummer i leverantörens fortnox',
  extendId: 'Artikelnummer i Extend',
  extendUrl: 'Nummer i Extend',
  extendClientId: 'Klient ID i Extend',
};

// Internal mapping of metadata keys to transform functions
const attributeTransforms: Partial<Record<string, (value: any) => string>> = {
  fortnoxUrl: (value: string) => {
    if (!value) return '';
    return value.split('/').pop() || value;
  },
  externalFortnoxUrl: (value: string) => {
    if (!value) return '';
    return value.split('/').pop() || value;
  },
  extendUrl: (value: string) => {
    if (!value) return '';
    return value.split('/').pop() || value;
  },
  extendClientId: (value: string) => {
    if (!value) return '';
    return value.split('/').pop() || value;
  },
};

export interface MetadataAlertProps {
  metadata?: Record<string, any>;
}

const MetadataAlert: React.FC<MetadataAlertProps> = ({ metadata }) => {
  if (!metadata || Object.keys(metadata).length === 0) return null;

  return (
    <Alert color="info" className="my-2">
      {Object.entries(metadata)
        .filter(([key, value]) => !!value)
        .map(([key, value]) => (
          <div key={key}>
            {attributeLabels[key] || key}:
            <strong>
              {' '}
              {attributeTransforms[key]
                ? attributeTransforms[key]!(value)
                : String(value)}
            </strong>
          </div>
        ))}
    </Alert>
  );
};

export default MetadataAlert;
